<template>
  <div>
    <v-combobox
      class="combobox"
      v-model="selectedAttendees"
      :items="peoples"
      :label="`${$t('agenda.lblAttendees')} *`"
      :rules="[(v) => !!(v && v.length) || $t('agenda.ruleAttendeeReq')]"
      required
      multiple
      small-chips
      item-text="email"
      item-value="id"
      :hint="$t('lblAttendeesHint')"
      :persistent-hint="isEmailvalidate"
      return-object
      @input="onUpdate"
      @focus="isFocused"
      dense
      filled
    >
      <template v-slot:selection="data">
        <v-chip
          small
          :key="JSON.stringify(data.item)"
          v-bind="data.attrs"
          :input-value="data.selected"
          :disabled="data.disabled"
          @click:close="data.parent.selectItem(data.item)"
          color="secondary darken-3"
          class="ma-1 pl-2"
        >
          <v-avatar v-if="data.item.email" left>
            <v-img
              v-if="data.item.profilePhoto"
              contain
              :src="data.item.profilePhoto"
            ></v-img>
            <v-img v-else contain src="@/assets/images/NoPhotoIcon.png"></v-img>
          </v-avatar>
          <span v-if="data.item.firstName">
            {{ data.item.firstName + " " + data.item.lastName }}</span
          >
          <span v-else> {{ data.item.email }}</span>
        </v-chip>
      </template>

      <template v-slot:item="{ item, attrs, on }">
        <v-list-item v-on="on" v-bind="attrs" #default="{ active }" dense>
          <v-checkbox dense :input-value="active"></v-checkbox>
          <v-list-item-avatar class="mt-0 mb-0" size="30">
            <v-img
              v-if="item.profilePhoto"
              contain
              :src="item.profilePhoto"
            ></v-img>
            <v-img v-else contain src="@/assets/images/NoPhotoIcon.png"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <span v-if="item.firstName">
              {{ item.firstName + " " + item.lastName }}
            </span>
            <span v-else>{{ item.email }}</span>
            <v-list-item-subtitle v-if="item.firstName">
              {{ item.email }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-combobox>

    <v-list class="mt-2" lines="two" v-if="false">
          <v-list-item
            v-for="item in selectedAttendees"
            :key="item.id"
            
          >
          <v-list-item-avatar class="mt-0 mb-0" size="30">
              <v-img
                v-if="item.profilePhoto"
                contain
                :src="item.profilePhoto"
              ></v-img>
              <v-img v-else contain src="@/assets/images/NoPhotoIcon.png"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <span v-if="item.firstName">
                {{ item.firstName + " " + item.lastName }}
              </span>
              <span v-else>{{ item.email }}</span>
              <v-list-item-subtitle v-if="item.firstName">
                {{ item.email }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <template v-slot:append>
              <v-btn
                color="grey-lighten-1"
                icon="mdi-information"
                variant="text"
              ></v-btn>
              </template>
          </v-list-item>
        </v-list>
</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { createUUID } from "../../utils/util";
export default {
  name: "MeetingParticipant",
  data() {
    return {
      isEmailvalidate: true,
      selectedAttendees: null,
    };
  },
  watch: {
    meetingAtteendeelist() {
      this.selectedAttendees =
        this.meetingAtteendeelist.length > 0 ? this.meetingAtteendeelist : null;
    },
    selectedAttendees(value) {
      if (value) {
        let entry = this.selectedAttendees[this.selectedAttendees.length - 1];
        if (!entry) {
          return;
        }
        if (entry.email) {
          const existingPerson = this.peoples.find(
            (f) => f.email === entry.email
          );
          if (!existingPerson) {
            this.selectedAttendees[this.selectedAttendees.length - 1] =
              this.addItem(entry);
          }
        } else {
          if (validateEmail(entry)) {
            this.isEmailvalidate = true;
            this.selectedAttendees[this.selectedAttendees.length - 1] =
              this.addItem(entry);
          } else {
            this.isEmailvalidate = true;
            this.selectedAttendees.pop();
          }
        }
        this.$emit("onSelection", this.selectedAttendees);
      }
    },
  },
  props: {
    meetingAtteendeelist: Array,

    value: {
      type: Array,
      default: () => [],
    },
  },
  async mounted() {
    // await this.getPeopleList();
    // await this.getUserList();
    this.selectedAttendees =
      this.meetingAtteendeelist && this.meetingAtteendeelist.length > 0
        ? this.meetingAtteendeelist
        : null;
  },
  computed: {
    ...statesMap(),
    selectedAttendeesO: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || []);
      },
    },

    mappedPeopleList() {
      let listPeople = [];
      this.userList.forEach((user) => {
       listPeople.push({
            id: user.id,
            email: user.display_email ? user.display_email : user.registered_email,
            firstName: user.firstName,
            lastName: user.lastName,
            profilePhoto: user.profilePhoto,
          });
      });
      return listPeople;
    },
    peoples() {
      var Emailids = new Set(this.mappedPeopleList.map((d) => d.email));
      if (this.selectedAttendees) {
        return [
          ...this.mappedPeopleList,
          ...this.selectedAttendees.filter((d) => !Emailids.has(d.email)),
        ];
      } else {
        return this.mappedPeopleList;
      }
    },
  },
  methods: {
    ...mapActions({
    }),
    createUUID,
    addItem(emailId) {
      const newItem = {
        id: createUUID(),
        email: emailId,
      };
      return newItem;
    },
    isFocused(){
      setTimeout(function(){ 
      const menuable = document.getElementsByClassName("v-select-list");
            if(menuable.length > 0){
                menuable[0].scrollIntoView({
                  behavior: "instant",
                  block: "start",
                  inline: "start",
              });
            }
       }, 100);
    },
    onUpdate(value) {
      if (value) {
        if (value.length === 0) {
          this.selectedAttendees = null;
        }
      }
    },
  },
};

const validateEmail = (email) => {
  return email.match(
    /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/
  );
};

function statesMap() {
  return mapState({
    // peopleList: (state) => state.people.peopleList,
    // userList: (state) => state.admin.userList,
    userList: (state) => state.people.userList,
  });
}
</script>
<style scoped>
::v-deep .v-input__control {
  max-height: 100% !important;
}
.v-text-field--filled {
  border-radius: 0px !important;
}
.combobox /deep/ .v-input__slot {
  min-height: 48px !important;
}
</style>